import { createContext } from "react";

const externalusersContext = createContext();

export default externalusersContext;